import React from "react";
import SidePanelHeader from "./SidePanelHeader";
import { Drawer } from "@mui/material";

const AlertsDrawer = ({ handleClose, open, finalDate }) => {
  const drawerPaper = {
    "& .MuiDrawer-paper": {
      borderRadius: "20px 0px 0px 20px",
    },
  };
  return (
    <Drawer anchor="right" open={open} onClose={handleClose} sx={drawerPaper}>
      <SidePanelHeader
        type="company"
        id=""
        page="production"
        finalDate={finalDate}
        handleClose={handleClose}
      />
    </Drawer>
  );
};

export default AlertsDrawer;
